import { render, staticRenderFns } from "./toclz.vue?vue&type=template&id=cb8a310e&scoped=true"
import script from "./toclz.vue?vue&type=script&lang=js"
export * from "./toclz.vue?vue&type=script&lang=js"
import style0 from "./toclz.vue?vue&type=style&index=0&id=cb8a310e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8a310e",
  null
  
)

export default component.exports